// packages/shared-hooks/src/clients/useAddLegalEntityRequisites.ts
//
// `POST /clients/:id/legal-entities/:legalEntityId/requisites` — adds one
// bank-requisites set to a legal entity. `details` is required; `bankName` /
// `bik` / `account` keep their optional/null semantics (omitted = untouched,
// explicit `null` = cleared), so a form that always serialises the slots does
// not invent empty strings.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  LegalEntityRequisitesSchema,
  type LegalEntityRequisites,
  type LegalEntityRequisitesInput,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function useAddLegalEntityRequisites(clientId: string, legalEntityId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<LegalEntityRequisites, unknown, LegalEntityRequisitesInput>({
    mutationFn: (input) =>
      client.post<LegalEntityRequisites>(
        `/clients/${clientId}/legal-entities/${legalEntityId}/requisites`,
        input,
        {},
        LegalEntityRequisitesSchema,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: clientsKeys.detail(clientId) });
      void qc.invalidateQueries({ queryKey: clientsKeys.all });
    },
  });
}
